import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { DialogTitle, Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdArrowBack } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { Button } from "rsuite";
import { web_url } from "../../constant";
import axios from "axios";

function ResearcherDownloadData() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();


    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [fileDetails, setFileDetails] = useState({
        fileType: ''
    })

    const [error, setError] = useState({
        noFileType: false,
    })

    const [openError, setOpenError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setErrorMsg(t('t93'));
            // console.log("1");

        } else if (err.toLowerCase().includes('found')) {
            setErrorMsg(t('t258'));
            // console.log("2");
        } else if (err.toLowerCase().includes('already sent')) {
            setErrorMsg(t('t259'));
            // console.log("2");
        } else {
            setErrorMsg(t('t94'));
            // console.log("3");
        }
        setIsLoading(false);
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
        setFileDetails(() => ({ fileType: "" }))
    };

    const handleButtonClick = () => {
        let newErrors = {};

        newErrors.noFileType = !fileDetails.fileType;

        setError(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }

        // console.log(JSON.parse(localStorage.getItem('teachersignup1')));
        // handleClickOpen2();
        if (selectedButton === 1) {
            handleClickStuRandom();
        } else if (selectedButton === 2) {
            handleClickTransPayment();
        } else if (selectedButton === 3) {
            handleClickTeacherContact();
        } else if (selectedButton === 4) {
            handleClickEmailThreads();
        } else if (selectedButton === 5) {
            handleClickUnmatchedStudents();
        } else if (selectedButton === 6) {
            handleClickMatchedStudents();
        }
    }

    const [open2, setOpen2] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    // const recepientArray = ['Teacher', 'Translator', 'Researcher',];
    const [fileTypeArray, setFileTypeArray] = useState(["Text", "CSV","HTML"]);

    const [selectedButton, setSelectedButton] = useState(1);

    useEffect(() => {
        if (selectedButton === 5 || selectedButton === 6) {
            setFileTypeArray(["Excel"])
        } else if (selectedButton !== 4) {
            setFileTypeArray(["CSV"])
        } else {
            setFileTypeArray(["HTML"])
        }
    }, [selectedButton])

    const handleClickStuRandom = () => {
        setIsLoading(true);

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };

        axios.get(`${web_url}/api/auth/students`, configToken).then((response) => {
            const controlGrp = response.data.filter(student => student.penpalGroup === "CONTROL")
            const treatmentGrp = response.data.filter(student => student.penpalGroup === "TREATMENT")

            const selectedFields = [
                'userFullName', 'userEmail', 'penpalEmail', 'userRole',
                'school', 'district', 'grade', 'assignedClass', 'teacherName',
                'gender', 'dateOfBirth', 'preferredLanguage', 'accountStatus', 'personalInterests'
            ];

            const headers = selectedFields.join(',');

            // Function to format personal interests
            const formatInterests = (interests) => {
                if (!interests) return '';
                return Object.entries(interests)
                    .map(([key, values]) => `${key}: ${values.join('; ')}`)
                    .join(' | ');
            };

            // Function to format rows for CSV
            const formatRows = (group) =>
                group.map(student =>
                    selectedFields.map(field =>
                        field === 'personalInterests'
                            ? `"${formatInterests(student[field])}"`
                            : `"${student[field] || ''}"`
                    ).join(',')
                ).join('\n');

            // Construct CSV content
            let csvContent = `CONTROL GROUP\n${headers}\n${formatRows(controlGrp)}\n\n`;
            csvContent += `TREATMENT GROUP\n${headers}\n${formatRows(treatmentGrp)}`;

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'students.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setIsLoading(false);


        }).catch((err) => {
            console.log(error);

            setIsLoading(true);
        })
    }

    const handleClickTransPayment = () => {
        setIsLoading(true);

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };

        axios.get(`${web_url}/api/auth/payments`, configToken).then((response) => {

            const selectedFields = [
                'name', 'email', 'bankName', 'accountNumber', 'branch'
            ];

            const headers = selectedFields.join(',');

            // Function to format rows for CSV
            const formatRows = (group) =>
                group.map(payment =>
                    selectedFields.map(field => `"${payment[field] || ''}"`).join(',')
                ).join('\n');

            // Construct CSV content
            let csvContent = `${headers}\n${formatRows(response.data)}`;

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'payment.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setIsLoading(false);


        }).catch((err) => {
            console.log(error);

            setIsLoading(true);
        })
    }

    const handleClickTeacherContact = () => {
        setIsLoading(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };
        axios.get(`${web_url}/api/auth/teachers`, configToken).then((response) => {

            const selectedFields = [
                'id', 'userEmail', 'userFullName', 'userRole', 'district', 'school', 'assignedClass', 'contactNumber'
            ];

            const headers = selectedFields.join(',');

            // Function to format rows for CSV
            const formatRows = (group) =>
                group.map(teacher =>
                    selectedFields.map(field => `"${teacher[field] || ''}"`).join(',')
                ).join('\n');

            // Construct CSV content
            let csvContent = `${headers}\n${formatRows(response.data)}`;

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'teachers.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setIsLoading(false);


        }).catch((err) => {
            console.log(error);

            setIsLoading(true);
        })
    }

    // const handleClickEmailThreads = () => {
    //     setIsLoading(true);

    //     const getLogDetails = () => {
    //         return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
    //     };
    //     const logDetails = getLogDetails();

    //     const configToken = {
    //         headers: {
    //             'Authorization': `Bearer ${logDetails.token}`,
    //         },
    //     };

    //     axios.get(`${web_url}/api/auth/students`, configToken).then((res) => {

    //         const controlStudents = res.data.filter(student => student.penpalGroup === "CONTROL").map(student => student.userEmail);
    //         const treatmentStudents = res.data.filter(student => student.penpalGroup === "TREATMENT").map(student => student.userEmail);

    //         axios.get(`${web_url}/api/email-threads`, configToken).then((response) => {
    //             // console.log(response.data);

    //             // const filteredControlThreads = response.data.filter(thread => (controlStudents.includes(thread.participants[0])) && thread.messages[0].type === "PENPAL");
    //             const filteredTreatmentThreads = response.data.filter(thread => (treatmentStudents.includes(thread.participants[0])) && thread.messages[0] && thread.messages[0].type && thread.messages[0].type === "PENPAL");
    //             const filteredControlThreads = response.data.filter(thread => (controlStudents.includes(thread.participants[0])) && thread.messages[0] && thread.messages[0].type && thread.messages[0].type === "PENPAL");


    //             const stripHtml = (html) => {
    //                 if (typeof html !== 'string') return '';
    //                 const cleanText = html.replace(/<[^>]*>?/gm, '');
    //                 const textarea = document.createElement('textarea');
    //                 textarea.innerHTML = cleanText;
    //                 return textarea.value;
    //             };

    //             // Function to format email thread data with tab spacing
    //             const formatThreads = (group) =>
    //                 group.map(thread => {
    //                     let messages = thread.messages.map(msg =>
    //                         `\nSender: ${msg.sender}, Receiver:${thread.participants.filter(p => p !== msg.sender)}\nTime: ${msg.sentAt}\nStatus: ${msg.status}\nLanguage: ${msg.language}\nOriginal Message:  ${msg.body ? stripHtml(msg.body) : "NA"}\nEnglish message: ${msg.englishBody ? stripHtml(msg.englishBody) : "NA"}\n\n`
    //                     ).join('');
    //                     let student1Email = thread.participants[0];
    //                     let student2Email = thread.participants[1] || "N/A";

    //                     return `Penpals: ${student1Email} , ${student2Email}\n\nMessages:\n${messages}`;
    //                 }).join('\n-------------------\n');

    //             // Construct text content
    //             let textContent = `TREATMENT\n\n${formatThreads(filteredTreatmentThreads)}\n`;
    //             textContent += `CONTROL\n\n${formatThreads(filteredControlThreads)}`;

    //             const blob = new Blob([textContent], { type: 'text/plain;charset=utf-8;' });
    //             const url = URL.createObjectURL(blob);

    //             const link = document.createElement('a');
    //             link.href = url;
    //             link.setAttribute('download', 'email_threads.txt');
    //             document.body.appendChild(link);
    //             link.click();
    //             document.body.removeChild(link);

    //             setIsLoading(false);


    //         }).catch((err1) => {
    //             console.log(err1);

    //             setIsLoading(false);
    //         })

    //     }).catch((err2) => {
    //         console.log(err2);

    //         setIsLoading(false);
    //     })
    // }

    const handleClickEmailThreads = () => {
        setIsLoading(true);

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };

        axios.get(`${web_url}/api/auth/students`, configToken).then((res) => {
            const controlStudents = res.data.filter(student => student.penpalGroup === "CONTROL").map(student => student.userEmail);
            const treatmentStudents = res.data.filter(student => student.penpalGroup === "TREATMENT").map(student => student.userEmail);
            const allStudentEmails = res.data.map(student => student.userEmail);

            axios.post(`${web_url}/api/email-threads/by-participants`, allStudentEmails, configToken).then((response) => {
                const filteredTreatmentThreads = response.data.filter(thread => (treatmentStudents.includes(thread.participants[0])) && thread.messages[0]?.type === "PENPAL");
                const filteredControlThreads = response.data.filter(thread => (controlStudents.includes(thread.participants[0])) && thread.messages[0]?.type === "PENPAL");


                const stripHtml = (html) => {
                    if (typeof html !== 'string') return '';
                    const cleanText = html.replace(/<[^>]*>?/gm, '');
                    const textarea = document.createElement('textarea');
                    textarea.innerHTML = cleanText;
                    return textarea.value;
                };

                const formatThreadsHtml = (group) =>
                    group.map(thread => {
                        let messages = thread.messages.map(msg => {
                            const sender = msg.sender;
                            const receiver = thread.participants.find(p => p !== sender) || "N/A";
                            const sentAt = msg.sentAt;
                            const status = msg.status || "NA";
                            const language = msg.language || "NA";
                            const originalMessage = msg.body ? stripHtml(msg.body) : "NA";
                            const englishMessage = msg.englishBody ? stripHtml(msg.englishBody) : "NA";

                            return `
                            <div class="message">
                                <p><strong>Sender:</strong> ${sender}, <strong>Receiver:</strong> ${receiver}</p>
                                <p><strong>Time:</strong> ${sentAt}</p>
                                <p><strong>Status:</strong> ${status}</p>
                                <p><strong>Language:</strong> ${language}</p>
                                <p><strong>Original Message:</strong><br>${originalMessage}</p>
                                <p><strong>English Message:</strong><br>${englishMessage}</p>
                            </div>
                        `;
                        }).join('');

                        const student1 = thread.participants[0];
                        const student2 = thread.participants[1] || "N/A";

                        return `
                        <div class="thread">
                            <h3>Penpals: ${student1} , ${student2}</h3>
                            ${messages}
                        </div>
                    `;
                    }).join('\n-------------------\n');

                // Build the full HTML page
                const htmlContent = `
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <title>Email Threads</title>
                   <style>
    body {
        font-family: Arial, sans-serif;
        margin: 20px;
        line-height: 1.3;
    }
    h1 {
        font-size: 22px;
        color: #333;
        margin: 16px 0 8px;
    }
    h3 {
        font-size: 16px;
        color: #222;
        margin: 10px 0 6px;
    }
    .message {
        margin: 12px 0; /* ⬅️ increased vertical spacing between messages */
        padding: 8px;
        border: 1px solid #ddd; /* optional for visibility */
        border-radius: 4px;
        background-color: #f9f9f9;
    }
    .message p {
        margin: 2px 0;
    }
    .thread {
        margin-bottom: 20px;
    }
</style>
                </head>
                <body>
                    <h1>TREATMENT GROUP</h1>
                    ${formatThreadsHtml(filteredTreatmentThreads)}

                    <h1>CONTROL GROUP</h1>
                    ${formatThreadsHtml(filteredControlThreads)}
                </body>
                </html>
            `;

                // Create the downloadable HTML file
                const blob = new Blob([htmlContent], { type: 'text/html;charset=utf-8;' });
                const url = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'email_threads.html');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                setIsLoading(false);

            }).catch((err1) => {
                console.log(err1);
                setIsLoading(false);
            });

        }).catch((err2) => {
            console.log(err2);
            setIsLoading(false);
        });
    };



    const handleClickUnmatchedStudents = () => {
        setIsLoading(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };
        axios.get(`${web_url}/api/auth/students-without-penpal/excel`, { ...configToken, responseType: 'blob' })
            .then((response) => {
                setIsLoading(false);

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const a = document.createElement('a');
                a.href = url;
                a.download = 'students_without_penpal.xlsx';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            })
            .catch((err) => {
                console.error(err);
                setIsLoading(false);
            });
    };

    const handleClickMatchedStudents = () => {
        setIsLoading(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };
        axios.get(`${web_url}/api/auth/students/export-matches`, { ...configToken, responseType: 'blob' })
            .then((response) => {

                setIsLoading(false);

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const a = document.createElement('a');
                a.href = url;
                a.download = 'students_with_penpal.xlsx';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            })
            .catch((err) => {
                console.error(err);
                setIsLoading(false);
            });
    };

    return (
        <>
            <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} overflow-x-hidden xl:pt-[20px] min-h-screen`}>
                <div className="pt-[100px] md:pt-[130px] lg:pt-[150px] xl:pt-[0px] w-full">
                    <div className="ml-[30px] md:ml-[60px] lg:ml-[80px] xl:ml-[80px] w-full flex justify-start flex items-center">
                        <MdArrowBack size={25} className="md:hidden" onClick={() => {
                            navigate('/mobile/researcher/dashboard')
                        }} />
                        <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                            navigate('/mobile/researcher/dashboard')
                        }} />
                        <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                            navigate('/desktop/researcher/dashboard')
                        }} />
                        <p className="text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px] font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]">{t('t286')}</p>
                    </div>
                </div>

                {
                    isLoading ? <div className="items-center justify-center flex pt-[30px]">
                        <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                    </div> :

                        <>

                            <div className="mt-[30px] md:mt-[100px] xl:mt-[70px] ml-[20px] mr-[20px] md:ml-[100px] md:mr-[100px] lg:ml-[250px] lg:mr-[250px] xl:ml-[400px] xl:mr-[400px] 2xl:ml-[600px] 2xl:mr-[600px] items-center flex justify-center">
                                <div className="grid grid-cols-1 xl:grid-cols-2 xl:gap-[20px]">
                                    <button onClick={() => {
                                        setFileDetails("")
                                        setSelectedButton(1)
                                    }} className={`${selectedButton === 1 ? 'text-[#DBE8FA]' : 'bg-opacity-30 text-[#2B4B79]'} font-bold text-[17px] md:text-[21px] lg:text-[23px] xl:text-[18px] lg:py-[20px] xl:py-[15px]  rounded-lg  py-[10px] px-[45px] md:px-[50px] lg:px-[70px] xl:px-[60px] border border-[#8189B0] bg-[#8189B0] mb-[15px]`}>{t('t287')}</button>
                                    <button onClick={() => {
                                        setFileDetails("")
                                        setSelectedButton(2)
                                    }} className={`${selectedButton === 2 ? 'text-[#DBE8FA]' : 'bg-opacity-30 text-[#2B4B79]'} font-bold text-[17px] md:text-[21px] lg:text-[23px] xl:text-[18px] lg:py-[20px] xl:py-[15px]  rounded-lg  py-[10px]  px-[45px] md:px-[50px] lg:px-[70px] xl:px-[60px] border border-[#8189B0] bg-[#8189B0] mb-[15px]`}>{t('t288')}</button>
                                    <button onClick={() => {
                                        setFileDetails("")
                                        setSelectedButton(3)
                                    }} className={`${selectedButton === 3 ? 'text-[#DBE8FA]' : 'bg-opacity-30 text-[#2B4B79]'} font-bold text-[17px] md:text-[21px] lg:text-[23px] xl:text-[18px] lg:py-[20px] xl:py-[15px]  rounded-lg  py-[10px] px-[45px] md:px-[50px] lg:px-[70px] xl:px-[60px] border border-[#8189B0] bg-[#8189B0] mb-[15px]`}>{t('t289')}</button>
                                    <button onClick={() => {
                                        setFileDetails("")
                                        setSelectedButton(4)
                                    }} className={`${selectedButton === 4 ? 'text-[#DBE8FA]' : 'bg-opacity-30 text-[#2B4B79]'} font-bold text-[17px] md:text-[21px] lg:text-[23px] xl:text-[18px] lg:py-[20px] xl:py-[15px]  rounded-lg  py-[10px]  px-[45px] md:px-[50px] lg:px-[70px] xl:px-[60px] border border-[#8189B0] bg-[#8189B0] mb-[15px]`}>{t('t290')}</button>
                                    <button onClick={() => {
                                        setFileDetails("")
                                        setSelectedButton(5)
                                    }} className={`${selectedButton === 5 ? 'text-[#DBE8FA]' : 'bg-opacity-30 text-[#2B4B79]'} font-bold text-[17px] md:text-[21px] lg:text-[23px] xl:text-[18px] lg:py-[20px] xl:py-[15px]  rounded-lg  py-[10px]  px-[45px] md:px-[50px] lg:px-[70px] xl:px-[60px] border border-[#8189B0] bg-[#8189B0] mb-[15px]`}>{t('t352')}</button>
                                    <button onClick={() => {
                                        setFileDetails("")
                                        setSelectedButton(6)
                                    }} className={`${selectedButton === 6 ? 'text-[#DBE8FA]' : 'bg-opacity-30 text-[#2B4B79]'} font-bold text-[17px] md:text-[21px] lg:text-[23px] xl:text-[18px] lg:py-[20px] xl:py-[15px]  rounded-lg  py-[10px]  px-[45px] md:px-[50px] lg:px-[70px] xl:px-[60px] border border-[#8189B0] bg-[#8189B0] mb-[15px]`}>{t('t404')}</button>

                                </div>
                            </div>

                            <div className="ml-[45px] mr-[45px] md:ml-[200px] md:mr-[200px] lg:ml-[300px] lg:mr-[300px] xl:ml-[410px] xl:mr-[410px] 2xl:ml-[610px] 2xl:mr-[610px] items-center mt-[20px] md:mt-[40px] xl:mt-[10px] flex justify-center">
                                <Menu as="div" className="w-full  relative inline-block text-left pt-[20px] pb-[5px]">
                                    <div>
                                        <MenuButton
                                            className={`truncate pl-[20px] inline-flex w-full justify-left items-center rounded-md bg-[#F1F6FB] h-[50px] md:h-[60px] xl:h-[50px] 2xl:h-[60px] text-[15px] ${fileDetails.fileType === "" ? 'text-gray-500' : 'text-gray-900'} shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px]`}
                                        >
                                            <p className="pr-[10px] text-gray-500">{t('t291')}</p>
                                            {fileDetails.fileType === "" ? t('t292') : fileDetails.fileType}
                                            <ChevronDownIcon
                                                aria-hidden="true"
                                                className="absolute right-[10px] size-5 text-gray-700"
                                            />
                                        </MenuButton>
                                    </div>

                                    <MenuItems
                                        transition
                                        className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                                        style={{
                                            width: '100%',
                                            maxHeight: '300px',
                                            overflowY: 'auto'
                                        }}
                                    >
                                        <div className="py-1">
                                            {
                                                fileTypeArray.map((recepientSelect, index) => (
                                                    <MenuItem key={index}>
                                                        <button
                                                            className="truncate text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                                            onClick={() => {
                                                                setFileDetails((prev) => ({ ...prev, fileType: recepientSelect }))
                                                            }}
                                                        >
                                                            {recepientSelect}
                                                        </button>
                                                    </MenuItem>
                                                ))
                                            }
                                        </div>
                                    </MenuItems>
                                </Menu>
                            </div>

                            {error.noFileType &&
                                <p className='text-[#ff0000] text-[12px] mt-[5px] ml-[50px] mr-[20px] md:ml-[180px] md:mr-[100px] lg:ml-[270px] lg:mr-[250px] xl:ml-[430px] xl:mr-[400px] 2xl:ml-[630px]'>Please select a formtat</p>
                            }

                            <div className="flex justify-center mt-[20px] xl:mt-[30px] mb-[120px] xl:mb-[20px]">
                                <button onClick={handleButtonClick} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[250px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">{t('t133')}</button>
                            </div>

                        </>
                }

            </div>

            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-[#FFF6DA]">
                    {!isLoading &&
                        <DialogContent
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            <div className='flex flex-col justify-center items-center text-center'>
                                <img src='/images/success.svg' alt='success' />
                                <div className='mt-[30px] mb-[20px]'>{t('t127_2')}</div>
                                <Button
                                    onClick={handleClose}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t96')}
                                </Button>
                            </div>
                        </DialogContent>
                    }
                </DialogContent>
            </Dialog>

            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {errorMsg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2 ">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ResearcherDownloadData;
